var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.questionData != null
    ? _c("div", { staticClass: "exam_right" }, [
        _c("div", { staticClass: "border" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right_main" },
          [
            _vm.questionData.questionDto.internalTypeId === 1
              ? _c("Single")
              : _vm._e(),
            _vm._v(" "),
            _vm.questionData.questionDto.internalTypeId === 2
              ? _c("More")
              : _vm.questionData.questionDto.internalTypeId === 3
              ? _c("Judge")
              : _vm.questionData.questionDto.internalTypeId === 6
              ? _c("Uncertain")
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right_foot" }, [
          _c(
            "div",
            { staticClass: "foot_content" },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.select },
                  model: {
                    value: _vm.isMake,
                    callback: function($$v) {
                      _vm.isMake = $$v
                    },
                    expression: "isMake"
                  }
                },
                [_vm._v(_vm._s(!_vm.isMake ? "标记" : "取消标记"))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "left",
                  attrs: { plain: "" },
                  on: { click: _vm.pre }
                },
                [_vm._v("上一题")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "right",
                  attrs: { plain: "" },
                  on: { click: _vm.next }
                },
                [_vm._v("下一题")]
              )
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-027180ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-027180ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testSumulationComponentNew/ExamRight.vue
// module id = null
// module chunks = 